<template>
    <div>
        <input
            v-model="value"
            type="range"
            :min="min"
            :max="max"
            :step="step"
        />
        <p>{{ scaledValue }}</p>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0,
        },
        min: {
            type: Number,
            default: -1,
        },
        max: {
            type: Number,
            default: 1,
        },
        step: {
            type: Number,
            default: 1,
        },
        scale: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        scaledValue() {
            return this.value * this.scale
        },
    },
}
</script>
